module.exports = __webpack_public_path__ + "img/Weapon_92.dfefae86.png";